import { redirect } from "@tanstack/react-router";
import { CLUBE_NO_AR } from "@/data/clube";

/** Páginas do clube e do quiz: com o clube fora do ar, voltam para a home (temporário).
 *  No `vite dev` (local e preview do Lovable) continuam abertas para revisão. */
export const exigirClubeNoAr = () => {
  if (!CLUBE_NO_AR && !import.meta.env.DEV) throw redirect({ to: "/", statusCode: 302 });
};
